import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PriceField from "Components/UI/Form/PriceField";

export default function StandardTerms({
  client,
  FORM_MODE,
  handleInputChange,
  agreementOptions,
  boolOptions,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="LatePaymentInterestPercentage"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Dröjsmålsränta %"
          value={client?.LatePaymentInterestPercentage}
          onChange={(e) =>
            handleInputChange("LatePaymentInterestPercentage", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
          <InputLabel>Referensränta adderas</InputLabel>
          <Select
            name="AddReferencePercentage"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={client.AddReferencePercentage}
            onChange={(e) =>
              handleInputChange("AddReferencePercentage", e.target.value)
            }
            label="Referensränta adderas"
            size="small"
          >
            {boolOptions.map((type) => (
              <MenuItem key={type.Value} value={type.Value}>
                {type.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="OriginalFfd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="FFD dagar"
          value={client?.OriginalFfd}
          onChange={(e) => handleInputChange("OriginalFfd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1WaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 skapas efter dagar"
          value={client.Pm1WaitCreate}
          onChange={(e) => handleInputChange("Pm1WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1Ffd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 FFD dagar"
          value={client.Pm1Ffd}
          onChange={(e) => handleInputChange("Pm1Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="Pm1Fee"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 Avgift SEK"
          value={client.Pm1Fee === null ? 0 : client.Pm1Fee}
          onChange={(newVal) => handleInputChange("Pm1Fee", newVal)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2WaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 Skapas efter dagar"
          value={client.Pm2WaitCreate}
          onChange={(e) => handleInputChange("Pm2WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2Ffd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 FFD dagar"
          value={client.Pm2Ffd}
          onChange={(e) => handleInputChange("Pm2Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="Pm2Fee"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 Avgift SEK"
          value={client.Pm2Fee}
          onChange={(newVal) => handleInputChange("Pm2Fee", newVal)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="CollectionWaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Inkasso fördröjning dagar"
          value={client.CollectionWaitCreate}
          onChange={(e) =>
            handleInputChange("CollectionWaitCreate", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="CNrCollection"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Klientnummer Inkasso"
          value={client.CNrCollection}
          onChange={(e) => handleInputChange("CNrCollection", e.target.value)}
          type="text"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PurchaseServiceAboveAmount"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Köp över belopp"
          value={client.PurchaseServiceAboveAmount}
          onChange={(e) =>
            handleInputChange("PurchaseServiceAboveAmount", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
    </Grid>
  );
}
